export default {
  namespaced: true,

  state: {
    currencies: [],
  },

  actions: {
    fetchCurrencies({ commit }) {
      const currencies = []
      commit('setCurrencies', currencies)
    }
  },

  mutations: {
    setCurrencies(state, currencies) {
      state.currencies = currencies
    },
  },
}
